<template>
  <v-menu
    ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="localTime"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="localTime"
        :label="label"
        prepend-icon="far fa-clock"
        readonly
        hide-details
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu2"
      :value="localTime"
      @input="updateTime"
      full-width
      @click:minute="saveTime"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "TimePickerMenu",
  props: {
    label: {
      type: String,
      default: "Seleccionar Hora",
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localTime: this.value,
      menu2: false,
    };
  },
  watch: {
    value(newValue) {
      this.localTime = newValue;
    },
  },
  methods: {
    updateTime(value) {
      this.localTime = value;
    },
    saveTime() {
      this.$refs.menu.save(this.localTime);
      this.$emit("input", this.localTime);
      this.$emit("updated", this.localTime);
    },
  },
};
</script>
